import React, { useState } from 'react';
import { Heart, MessageCircle, Share2, Gift, MapPin, MoreHorizontal, Send } from 'lucide-react';
export const YogaPost = () => {
  const [liked, setLiked] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [likeCount, setLikeCount] = useState(0);
  const [showMenu, setShowMenu] = useState(false);
  const handleLike = () => {
    if (!liked) {
      setLikeCount(likeCount + 1);
      setLiked(true);
    } else {
      setLikeCount(likeCount - 1);
      setLiked(false);
    }
  };
  const toggleMenu = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setShowMenu(!showMenu);
  };
  return <section className="w-full" data-id="element-23006">
      <div className="bg-white dark:bg-black rounded-xl sm:border sm:border-gray-200 overflow-hidden animate-in fade-in duration-300 relative" data-id="element-23007">
        <div className="p-3 flex items-center gap-2 border-b-0 sm:border-b sm:border-gray-200 dark:sm:border-gray-800/30" data-id="element-23008">
          <div className="w-10 h-10 rounded-full overflow-hidden" data-id="element-23009">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png" alt="GoldenShowerTina" className="w-full h-full object-cover" data-id="element-23010" />
          </div>
          <div data-id="element-23011">
            <div className="flex items-center gap-1" data-id="element-23012">
              <h3 className="font-medium text-gray-900 dark:text-white" data-id="element-23013">
                GoldenShowerTina
              </h3>
              <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-23014">
                • Just now
              </span>
            </div>
            <div className="flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400" data-id="element-23015">
              <span data-id="element-23016">Morning routine 🧘‍♀️</span>
              <MapPin size={10} className="ml-1" data-id="element-23017" />
              <span data-id="element-23018">Home</span>
            </div>
          </div>
          <button className="ml-auto" onClick={toggleMenu} data-post-id="yoga-post" data-id="element-23019">
            <MoreHorizontal size={16} className="text-gray-500 dark:text-gray-400" data-id="element-23020" />
          </button>
          {showMenu && <div className="absolute top-12 right-3 w-48 bg-white dark:bg-gray-800 rounded-lg border-0 sm:border sm:border-gray-200 dark:sm:border-gray-700/30 shadow-lg z-30" data-id="element-23021">
              <div className="py-1" data-id="element-23022">
                <button className="w-full px-4 py-2 text-left text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700" data-id="element-23023">
                  Follow Sophia
                </button>
                <button className="w-full px-4 py-2 text-left text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700" data-id="element-23024">
                  Mute
                </button>
                <button className="w-full px-4 py-2 text-left text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700" data-id="element-23025">
                  Report
                </button>
                <button className="w-full px-4 py-2 text-left text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700" data-id="element-23026">
                  Share
                </button>
              </div>
            </div>}
        </div>
        <div className="px-3 py-2" data-id="element-23027">
          <p className="text-sm text-gray-700 dark:text-gray-300" data-id="element-23028">
            Just finished my morning yoga session. How should I spend the rest
            of my day? 😉
          </p>
          <div className="text-xs text-pink-500 dark:text-pink-400 mt-1" data-id="element-23029">
            #morningroutine #yoga #wellness
          </div>
        </div>
        <div className="aspect-auto bg-gray-100 dark:bg-gray-800" data-id="element-23030">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cbRc9jayz6abrUqY99QsFF/pasted-image.jpg" alt="Morning yoga session" className="w-full h-full object-cover" data-id="element-23031" />
        </div>
        <div className="p-3" data-id="element-23032">
          <div className="flex items-center justify-between" data-id="element-23033">
            <div className="flex items-center gap-3" data-id="element-23034">
              <button className="flex items-center gap-1 group" onClick={handleLike} data-id="element-23035">
                <Heart size={18} className={liked ? 'text-pink-500' : 'text-gray-400 dark:text-gray-500 group-hover:text-pink-500 transition-colors'} data-id="element-23036" />
                <span className="text-xs text-gray-600 dark:text-gray-400" data-id="element-23037">
                  {likeCount > 0 ? likeCount : 'Like'}
                </span>
              </button>
              <button className="flex items-center gap-1" onClick={() => setShowComments(!showComments)} data-id="element-23038">
                <MessageCircle size={18} className="text-gray-400 dark:text-gray-500" data-id="element-23039" />
                <span className="text-xs text-gray-600 dark:text-gray-400" data-id="element-23040">
                  Comment
                </span>
              </button>
              <button className="flex items-center gap-1" data-id="element-23041">
                <Share2 size={18} className="text-gray-400 dark:text-gray-500" data-id="element-23042" />
                <span className="text-xs text-gray-600 dark:text-gray-400" data-id="element-23043">
                  Share
                </span>
              </button>
            </div>
            <button className="flex items-center gap-1" data-id="element-23044">
              <Gift size={18} className="text-purple-500 dark:text-purple-400" data-id="element-23045" />
              <span className="text-xs text-gray-600 dark:text-gray-400" data-id="element-23046">
                Gift
              </span>
            </button>
          </div>
          {showComments && <div className="mt-3 pt-3 border-t-0 sm:border-t sm:border-gray-200 dark:sm:border-gray-800/30" data-id="element-23047">
              <div className="flex gap-2 mt-3" data-id="element-23048">
                <div className="w-8 h-8 rounded-full overflow-hidden" data-id="element-23049">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uKJHSejmCauGrG6epCzaMk/image.png" alt="User" className="w-full h-full object-cover" data-id="element-23050" />
                </div>
                <div className="flex-1 relative" data-id="element-23051">
                  <input type="text" placeholder="Add a comment..." className="w-full bg-gray-100 dark:bg-gray-800 text-sm text-gray-700 dark:text-gray-300 rounded-full px-4 py-2 pr-10 outline-none border-0 sm:border sm:border-gray-200 dark:sm:border-gray-700/30 focus:border-pink-500" data-id="element-23052" />
                  <button className="absolute right-3 top-1/2 -translate-y-1/2" data-id="element-23053">
                    <Send size={16} className="text-pink-500 dark:text-pink-400" data-id="element-23054" />
                  </button>
                </div>
              </div>
            </div>}
        </div>
      </div>
    </section>;
};